import arrayToSentence from 'array-to-sentence';
import { metaKey } from '~/scripts/utils';
import { underscore } from 'inflected';

export default async ({ $api, route, store }) => {
  const metaTagOptions = metaKey(route, 'metaTagOptions') || {};
  let product;
  if (route.name.includes('life-insurance', 'mortgage-protection', 'serious-illness')) {
    product = underscore(store.getters['products/getCoverType'].product);
  } else {
    product = underscore(metaKey(route, 'product').split('/').pop());
  }

  if (product) {
    await $api('providers/providers', { product }).then(providers => {
      metaTagOptions.providers = arrayToSentence(providers.map(p => p.name));
      route.meta[0] = { ...route.meta[0], ...metaTagOptions };
      store.commit('providers/setList', providers);
    });
  }
};
